import React from 'react'
import { t } from 'ttag'
import { connect } from 'react-redux'
import { Modal } from 'react-bootstrap'
import { Link } from 'react-router-dom'

import help from '@h2/assets/svg/icons/infoCircle.svg'

import EducatorAssociationPanel from './educators/EducatorAssociationPanel'

import { requestManagementFromCode } from '../actions/editPersonalProfile'
import { lookupUserByCode, resetCode } from '../actions/miniHub'
import ActionButton from '../components/ActionButton'
import Form from '../components/form/Form'
import Field from '../components/form/Field'
import { useTitleChange } from '../util/hooks'

class MustAssociateInner extends React.PureComponent {
  /*
   * const { children } = props;
   * console.log(children, props)
   */
  constructor(props) {
    super(props)
    this.state = {
      requestedCode: null
    }
  }

  requestMgmtModalContent = () => {
    if (!(this.props.codeRequest.result && this.props.codeRequest.result.user)) {
      return null
    }

    if (this.props.mgmtCodeRequest.result) {
      if (this.props.mgmtCodeRequest.result.error) {
        return (
          <div>
            <div className="alert alert-danger">
              {this.props.mgmtCodeRequest.result.error}
            </div>
            <div className="actions text-center">
              <button
                className="btn btn-primary"
                onClick={() => this.props.dispatch(resetCode())}>
                {t`Close`}
              </button>
            </div>
          </div>
        )
      }

      return (
        <div>
          <div className="alert alert-warning">
            {this.props.mgmtCodeRequest.result.success}
          </div>
          <div className="actions text-center">
            <button
              className="btn btn-primary"
              onClick={() => this.props.dispatch(resetCode())}>
              {t`Close`}
            </button>
          </div>
        </div>
      )
    }

    return (
      <EducatorAssociationPanel
        codeRequest={this.props.codeRequest}
        onProceed={() =>
          this.props.dispatch(requestManagementFromCode(this.state.requestedCode))}
        onCancel={() => this.props.dispatch(resetCode())}
      />
    )
  }

  render() {
    const props = this.props
    const { children } = props

    return (
      <div className="association-message-box">
        <div className="container">
          <div className="row bordered-dialog-wrap association-wrap">
            {children ? (
              <div
                className="col-xs-7 left-col-w-arrow"
                style={{
                  backgroundColor: '#fff',
                  paddingTop: '25px',
                  fontSize: '1.2rem'
                }}>
                <h3 className="section-heading">{t`What is this Activity?`}</h3>
                {children}
              </div>
            ) : null}
            <div
              className={`col-xs-${children ? '5' : '12'} must-associate-container`}
              style={{ alignItems: 'center' }}>
              <div>
                <div className="text-center">
                  <img src={help} style={{ maxWidth: '80px' }} />
                </div>
                <h3 className="section-heading">{t`Before you can access this activity, you must Associate with an Educator`}</h3>
                <p>{t`In order to proceed, you must be an educator or have your account associated with one.`}</p>
                <div className="text-center">
                  <Form
                    className="form-inline"
                    model={'miniHub.forms.lookupCode'}
                    onSubmit={lesson => {
                      props.dispatch(lookupUserByCode(lesson.code)).then(code =>
                        this.setState({
                          ...this.state,
                          requestedCode: lesson.code
                        })
                      )
                    }}>
                    {form => (
                      <Field
                        model={`miniHub.forms.lookupCode.code`}
                        form={form}
                        placeholder={t`Enter Educator's Code`}
                        maxLength="6"
                        className="form-control input-lg"
                        required={true}
                        inlineFormAction={(
                          <ActionButton
                            internal={true}
                            className="btn btn-success no-style btn-lg"
                            type="submit">
                            {t`Request`}
                          </ActionButton>
                        )}>
                      </Field>
                    )}
                  </Form>
                </div>
                <p className="text-right">
                  <Link to="/requestmanagement">{t`I am an educator`}</Link>
                </p>
              </div>
            </div>
          </div>
          <Modal
            backdrop="static"
            bsSize="lg"
            show={!!(this.props.codeRequest.result && this.props.codeRequest.result.user)}
            onHide={() => this.props.dispatch(resetCode())}>
            <Modal.Header closeButton>
              <h2>{t`Request Management`}</h2>
            </Modal.Header>
            <Modal.Body>{this.requestMgmtModalContent()}</Modal.Body>
          </Modal>
        </div>
      </div>
    )
  }
}

const MustAssociateInnerComponent = connect(
  state => {
    return {
      ...state.personalProfile,
      ...state.miniHub
    }
  },
  dispatch => ({
    dispatch
  })
)(MustAssociateInner)
const MustAssociate = props => {
  const { pageTitle, ...rest } = props

  useTitleChange(pageTitle)

  return <MustAssociateInnerComponent {...rest} />
}

export default MustAssociate
